module.exports = __webpack_public_path__ + "img/sign-27.08095db7.jpg";